import type { ProductFragment } from '@/lib/types/datocms/graphql/generated'
import ProductSection from './ProductSection'
import { ProductPageSections } from '@/utils/datocms/sectionTypes'

type Props = {
	specifications: ProductFragment['specifications']
	inMegaMenu?: boolean
}

export function Specifications({ specifications, inMegaMenu }: Props) {
	return (
		<div className="specification-slices">
			{specifications.map((section: ProductPageSections) => (
				<ProductSection key={section.id} section={section} inMegaMenu={inMegaMenu} />
			))}
		</div>
	)
}
